import Box from '@components/base/Box'
import LoadingSpinner from '@components/base/LoadingSpinner'
import MiniNav from '@components/base/MiniNav'
import Modal, { ModalProps } from '@components/base/Modal'
import { Tab, Tabs } from '@components/base/Tabs'
import { Button } from '@components/inputs/Button'
import { DropdownInput } from '@components/inputs/DropdownInput'
import { TextInput } from '@components/inputs/TextInput'
import { ToggleInput } from '@components/inputs/ToggleInput'
import { MemberData } from '@components/metrics/TableMembers'
import { OrderData } from '@components/metrics/TableOrders'
import { useAuth } from '@libs/Auth/useAuth'
import React, { useEffect, useState } from 'react'

const MemberModal = (
  props: { data?: MemberData; onComplete: (data: MemberData) => void } & Omit<
    ModalProps,
    'children'
  >
) => {
  const { data, onComplete, className } = props

  const [modalData, setModalData] = useState<MemberData>(data as MemberData)
  const [tab, setTab] = useState<number>(0)

  useEffect(() => {
    if (data) setModalData(data as MemberData)
  }, [data])

  return (
    <Modal
      className={`flex flex-col items-center mt-14 text-white w-full ${className}`}
      {...props}
    >
      <Box className="flex flex-col justify-between">
        <Box className="flex-1 text-sm md:text-base break-all p-2">
          Member Email: {modalData?.customerEmail}
        </Box>
        <Box className="flex-1 text-sm md:text-base break-all p-2">
          Status: {modalData?.paid ? 'ACTIVE' : 'INACTIVE'}
        </Box>
        <Box className="flex-1 text-sm md:text-base break-all p-2">
          Last Renewal: {modalData?.lastUpdated}
        </Box>
        <Box className="flex-1 text-sm md:text-base break-all p-2">
          Stripe Price ID: {modalData?.priceId}
        </Box>
        <Box className="flex-1 text-sm md:text-base break-all p-2">
          Order ID: {modalData?.orderId}
        </Box>
      </Box>
    </Modal>
  )
}

export default MemberModal
